import AppConfigService from "../services/configService";

class Util {
  abp = window.abp;

  L(value, source, ...argus) {
    if (source) {
      return window.abp.localization.localize(value, source, argus);
    } else {
      return window.abp.localization.localize(
        value,
        AppConfigService.get().localization
          .defaultLocalizationSourceName,
        argus
      );
    }
  }

  floorDecimals(value, decimals) {
     return Number(Math.floor(value + 'e' + decimals) + 'e-' + decimals)
  }

  extend(...args) {
    let options,
      name,
      src,
      srcType,
      copy,
      copyIsArray,
      clone,
      target = args[0] || {},
      i = 1,
      length = args.length,
      deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = args[i] || {};
      i++;
    }
    if (typeof target !== "object" && typeof target !== "function") {
      target = {};
    }
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      if ((options = args[i]) !== null) {
        for (name in options) {
          src = target[name];
          copy = options[name];
          if (target === copy) {
            continue;
          }
          srcType = Array.isArray(src) ? "array" : typeof src;
          if (
            deep &&
            copy &&
            ((copyIsArray = Array.isArray(copy)) || typeof copy === "object")
          ) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && srcType === "array" ? src : [];
            } else {
              clone = src && srcType === "object" ? src : {};
            }
            target[name] = this.extend(deep, clone, copy);
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }
    return target;
  }

  getRouterObjByName(routers, name) {
    if (!name || !routers || !routers.length) {
      return null;
    }
    // debugger;
    let routerObj = null;
    for (let item of routers) {
      if (item.name === name) {
        return item;
      }
      routerObj = this.getRouterObjByName(item.children, name);
      if (routerObj) {
        return routerObj;
      }
    }
    return null;
  }

  toDefaultPage(routers, name, route, next) {
    let len = routers.length;
    let i = 0;
    let notHandle = true;
    while (i < len) {
      if (
        routers[i].name === name &&
        routers[i].children &&
        routers[i].redirect === undefined
      ) {
        route.replace({
          name: routers[i].children[0].name
        });
        notHandle = false;
        next();
        break;
      }
      i++;
    }
    if (notHandle) {
      next();
    }
  }

  flattenContainerTreee = (a, b) => {
    return a.reduce((p, c) => {
      c.childContainers
        ? (p.push(c), this.flattenContainerTreee(c.childContainers, p))
        : p.push(c);
      return p;
    }, b);
  };

  trimEndChars(str, endStr) {
    if (str.length < 1) {
      return str;
    }
    let result = str;
    while (result.endsWith(endStr)) {
      result = result.substr(0, result.length - endStr.length);
    }
    return result;
  }
  trimStartChars(str, startStr) {
    if (str.length < 1) {
      return str;
    }
    let result = str;
    while (result.startsWith(startStr)) {
      result = result.substr(startStr.length);
    }
    return result;
  }

  _radnomString(bits) {
    const ran = 1 + Math.random();
    return ((ran * 0x10000) | 0).toString(bits).substring(1);
  }

  uuid() {
    const bits = 16;
    const h = this._radnomString.bind(this, bits);
    return `${(h(), h())}-${(h(), h())}-${(h(), h())}-${(h(), h())}`;
  }

  paramArray(obj, param) {
    const exist = obj.hasOwnProperty(param);
    if (exist) throw new Error(`${obj.name} does not have a param ${param}`);
    return obj.reduce((acc, curr) => {
      acc.push(curr[param]);
      return acc;
    }, []);
  }
}

const util = new Util();

export default util;
